"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var ProgressBarCircleSvg_1 = __importDefault(require("../assets/ProgressBarCircleSvg"));
var VideoProgressBar_1 = __importDefault(require("./VideoProgressBar"));
var ProgressBarCircle = styled_components_1.default(ProgressBarCircleSvg_1.default).attrs(function (_a) {
    var progress = _a.progress;
    return ({
        style: {
            width: progress + "%",
        },
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fill: ", ";\n  position: relative;\n  top: -5px;\n  height: 0;\n  transition: top 0.2s ease, height 0.2s ease;\n\n  ", ":hover & {\n    height: 24px;\n    top: -16px;\n  }\n"], ["\n  fill: ", ";\n  position: relative;\n  top: -5px;\n  height: 0;\n  transition: top 0.2s ease, height 0.2s ease;\n\n  ", ":hover & {\n    height: 24px;\n    top: -16px;\n  }\n"])), function (_a) {
    var color = _a.color;
    return color;
}, VideoProgressBar_1.default);
exports.default = ProgressBarCircle;
var templateObject_1;
